import { HTTP_METHODS } from '@studio/constants/axios';
import { MEDIA_METADATA_API_V1 } from '@studio/constants/env-variables';
import type { Media } from '@studio/types';

export const root = {
  [HTTP_METHODS.POST]: {
    url: `${MEDIA_METADATA_API_V1}/customers/@customerId/media/bulk/delete`,
    response: {} as Media.Post.BulkDeleteResponse,
    params: {} as { mediaIds: string[] },
    method: HTTP_METHODS.POST,
  },
};
